import { FC } from 'react';

import { GaugeChartArcIcon } from '@/assets/icons';

import { GAUGE_CHART_TEST_IDS } from '../../../constants/data-testids';
import { Card, CardContent } from '../../atoms/Card/Card';
import { Skeleton } from '../../atoms/Skeleton/Skeleton';

type GaugeChartSkeletonProps = {
  description: string;
};

export const GaugeChartSkeleton: FC<GaugeChartSkeletonProps> = ({ description }) => {
  return (
    <Card
      data-testid={GAUGE_CHART_TEST_IDS.SKELETON}
      className="w-full rounded-[12px] p-4 bg-custom-warm-grey-25 py-[56.5px] px-[24px] flex items-center justify-center"
    >
      <CardContent className="max-w-[304px]">
        <div className="relative mb-[34px] flex items-center justify-center">
          <GaugeChartArcIcon className="animate-pulse" />

          <div className="absolute z-10 bottom-[30px] left-1/2 -translate-x-1/2 flex flex-col items-center gap-3">
            <Skeleton className="w-[80px] h-[14px] rounded-md" />
            <Skeleton className="w-[50px] h-[14px] rounded-md" />
          </div>
        </div>
        <p className="text-body-14-regular text-center !text-custom-warm-grey-500">{description}</p>
      </CardContent>
    </Card>
  );
};
